class CartDrawer extends HTMLElement {
  constructor() {
    super()

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    )
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    )
    this.setHeaderCartIconAccessibility()
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble")
    cartLink.setAttribute("role", "button")
    cartLink.setAttribute("aria-haspopup", "dialog")
    cartLink.addEventListener("click", (event) => {
      event.preventDefault()
      this.open(cartLink)
      pushViewCartTag()
    })
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault()
        this.open(cartLink)
        pushViewCartTag()
      }
    })
  }

  async updateCartProperties(lastName, code) {
    console.log("fasdfsa")

    // try {
    //   const cartResponse = await fetch("/cart.js")
    //   const cart = await cartResponse.json()

    //   const updates = cart.items.map((item) => {
    //     console.log("original_price==========", item.original_price)

    //     const payload = {
    //       id: item.id.toString(),
    //       properties: {
    //         _code: code,
    //         _lastName: lastName,
    //         _orgPrice: item.original_price,
    //         _disPrice: item.discounted_price,
    //       },
    //       quantity: item.quantity,
    //     }

    //     return fetch("/cart/change.js", {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //       body: JSON.stringify(payload),
    //     }).then((response) => response.json())
    //   })

    //   const results = await Promise.all(updates)
    //   console.log("Cart properties updated for the products in the cart:")
    //   console.log(results)
    // } catch (error) {
    //   console.error("Error updating cart properties:", error)
    // }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy)
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote)
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active")
    })
    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer")
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close")
        trapFocus(containerToTrapFocusOn, focusElement)
      },
      { once: true },
    )

    document.body.classList.add("overflow-hidden")

    const mileageData = JSON.parse(localStorage.getItem("unitedActivated"))
    let lastName = null,
      code = null
    if (mileageData !== null && typeof mileageData.lastName !== "undefined") {
      lastName = mileageData.lastName
    }
    if (mileageData !== null && typeof mileageData.code !== "undefined") {
      code = mileageData.code
    }

    const data = {
      attributes: {},
    }
    data.attributes["_code"] = code
    data.attributes["_lastName"] = lastName
    // console.log("data===", data)
    // Send an AJAX request to update the cart
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
  }

  close() {
    this.classList.remove("active")
    removeTrapFocus(this.activeElement)
    document.body.classList.remove("overflow-hidden")
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button")
    cartDrawerNote.setAttribute("aria-expanded", "false")

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      )
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      )
    })

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape)
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty")
    this.productId = parsedState.id
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id)
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      )
    })

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      )
      this.open()
      pushViewCartTag()
    })
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ]
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}

function changeVals(payload, cartId) {
  console.log("in function---", payload)
  const mileageData = JSON.parse(localStorage.getItem("unitedActivated"))
  let code = mileageData?.code || "null"
  let lastName = mileageData?.lastName || "null"
  const data = {
    attributes: {},
  }
  data.attributes["_code"] = code
  data.attributes["_lastName"] = lastName

  // Send an AJAX request to update the cart
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((cart) => {
      document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }))
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }))
      // Optionally, perform additional actions after update
    })
    .catch((error) => {
      console.error("Error updating cart:", error)
    })
  document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }))
  document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }))
  document.dispatchEvent(new CustomEvent("cart:update ", { bubbles: true }))
  for (let i = 0; i < payload.length; i++) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload[i]),
    })
      .then((response) => response.json())
      .then((cartVal) => {
        console.log("success")
        document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }))
        document.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true }),
        )
      })
    document.addEventListener("cart:updated", function () {
      console.log("teste")
    })
    document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true }))
    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }))
    document.dispatchEvent(new CustomEvent("cart:update ", { bubbles: true }))
    // return false;
    // updateCartItemAttr(cartId,original_price,final_price)
  }
}

customElements.define("cart-drawer", CartDrawer)

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ]
  }
}

customElements.define("cart-drawer-items", CartDrawerItems)

async function pushViewCartTag() {
  try {
    const cartResponse = await fetch("/cart.js")
    const cartData = await cartResponse.json()
    const { currency, total_price } = cartData
    const cartItems = []
    const lineItems = cartData.items
    for (const line_item of lineItems) {
      cartItems.push({
        item_id: line_item.product_id,
        item_name: line_item.title,
        item_category: line_item.product_type,
        item_variant: line_item.variant_title,
        price: line_item.price / 100,
        quantity: line_item.quantity,
      })
    }
    dataLayer.push({
      event: "view_cart",
      ecommerce: { currency, value: total_price / 100, items: cartItems },
    })
  } catch (error) {
    console.error("Error fetching cart data:", error)
  }
}
